export class AddressModel {
    town: string = 'Улаанбаатар'
    district: string = ''
    unit: string = ''
    street: string = ''
    /** The picked khoroo from the delivery area list; null = a free-text address. */
    deliveryAreaId: number | null = null

    static createAddressModel(obj: any) {
        let model = new AddressModel();
        model.town = obj.town;
        model.district = obj.district;
        model.unit = obj.unit;
        model.street = obj.street;
        model.deliveryAreaId = obj.deliveryAreaId ?? null;

        return model;
    }

    isValid(): boolean {
        return (this.town && this.district && this.unit && this.street) ? true : false;
    }

    toString() {
        return `${this.town} ${this.district} ${this.unit} ${this.street}`
    }
}